import i18n from '@/common/i18n';

export const passwordRule = () => ({
  type: 'string',
  required: true,
  message: i18n.t('Specify a password')
});

export const newPasswordRule = () => ({
  type: 'string',
  required: true,
  message: i18n.t('Specify new password'),
});

export const newPasswordRules = ({ currentPassword, validateCallback }) => ([
  newPasswordRule(),
  {
    validator: (rule, value, callback) => {
      const errors = [];
      if (value === currentPassword) {
        errors.push(i18n.t('New password must be different from the previous password'));
      }
      validateCallback?.();
      callback(errors);
    }
  }
]);

export const confirmPasswordRule = ({ newPassword }) => ({
  validator: (rule, value, callback) => {
    callback(value !== newPassword
        ? [i18n.t('Passwords do not match')]
        : []
      );
  }
});

export const emailRule = () => ({
  type: 'email',
  message: i18n.t('Specify a valid email')
});

export const contactEmailRule = () => ({
  required: true,
  message: i18n.t('Contact email is required')
});

export const regAccountRule = ({ isForced }) => ({
  required: !isForced,
  message: i18n.t('User name is required')
});

export const regPasswordRule = ({ isForced }) => ({
  required: !isForced,
  message: i18n.t('Password is required')
});

export const contactEmailRules = () => [
  contactEmailRule(),
  emailRule(),
];

export const totpCodeRule = () => ({
  required: true,
  pattern: /^\d{6}$/,
  message: i18n.t('Must be a 6-digit code')
});
